export default __webpack_public_path__ + "static/char-s-47-ko-c16675845ef9a73ec634da7cc0c454a1.png";